export const D39 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": 'colorTheme1',
        "title": "PMR",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'PMR Code',
                        "columnName": 'AgentCode',
                        "width": '170px',
                        "align": "left",
                        "sortable": true
                    },
                    {
                        "name": 'Employee Code',
                        "columnName": 'EmployeeCode',
                        "width": '170px',
                        "align": "left",
                        "sortable": true
                    },
                    {
                        "name": 'PMR Name',
                        "columnName": 'AgentName',
                        "width": '300px',
                        "align": "left",
                        "sortable": true
                    },
                    {
                        "name": 'Actual Sales',
                        "columnName": 'ActualSales',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    }
                ],
                "title": "AgentName",
                "endpoint": "D39",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "DistrictManagerCode", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {
                        "selectedValueColumn": "AgentEmployeeCode",
                        "selectedTitle": "Products",
                        "visual": [
                            {
                                "columns": 12,
                                "rows": 2,
                                "visual": {
                                    "id": 1,
                                    "type": "advancedTable",
                                    "colorTheme": 'colorTheme1',
                                    "title": "Products",
                                    "binding": {
                                        "data": {
                                            "columns": [
                                                {
                                                    "name": 'Product Name',
                                                    "columnName": 'ItemName',
                                                    "width": '400px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false,
                                                },
                                                {
                                                    "name": 'Actual Sales',
                                                    "columnName": 'ActualSales',
                                                    "width": '140px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true,
                                                },
                                                {
                                                    "name": 'Target',
                                                    "columnName": 'TargetSales',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true,
                                                },
                                                {
                                                    "name": 'Variance',
                                                    "columnName": 'Variance',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true,
                                                },
                                                {
                                                    "name": 'Performance %',
                                                    "columnName": 'Performance',
                                                    "width": '160px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": false,
                                                    "percent": true
                                                },
                                                {
                                                    "name": 'LY Sales',
                                                    "columnName": 'LYSales',
                                                    "width": '125px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true,
                                                },
                                                {
                                                    "name": 'Growth %',
                                                    "columnName": 'Growth',
                                                    "width": '118px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": false,
                                                    "percent": true
                                                }
                                            ],
                                            "title": "ItemName",
                                            "endpoint": "D39.1",
                                            "parameters": [
                                                { "key": "FromMonth", "value": "2024" },
                                                { "key": "FromYear", "value": "1" },
                                                { "key": "ToMonth", "value": "2024" },
                                                { "key": "ToYear", "value": "1" },
                                                { "key": "DistrictManagerCode", "value": "" },
                                                { "key": "AgentEmployeeCode", "value": "" },
                                                { "key": "ConfigTypeCode", "value": "" }
                                            ]
                                        },
                                        "context": {
                                            "point": {
                                                "onClick": {

                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        ]
                    }
                }
            }
        }
    }
}